import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import Layout, { Container } from "../components/layout";
import { toast } from "react-toastify";
import { getCookie } from "../config/webStorage";
import { FaEdit } from "react-icons/fa";
import { GoInfo } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const InputField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  readOnly = false,
}) => (
  <div>
    <label
      htmlFor={name}
      className="block text-sm font-medium text-gray-600 mb-1"
    >
      {label}
    </label>
    <input
      readOnly={readOnly}
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
);

const CreateEmployee = () => {
  let navigation = useNavigate();
  // const [formData, setFormData] = useState({
  //   personalDetails: {
  //     firstName: "",
  //     lastName: "",
  //     email: "",
  //     phone: "",
  //     maritalStatus: "",
  //     gender: "",
  //   },
  //   reportingManagerName: "",
  //   reportingManagerEmployeeCode: "",
  //   reportingManagerId: "",
  //   reportingManagerObjId: "",
  //   designation: "",
  //   department: "",
  //   employeeId: "",
  //   joiningDate: "",
  //   offerDetails: {
  //     workSchedule: "",
  //     offerLetterDate: "",
  //     offerAcceptedDate: "",
  //     joiningDate: "",
  //     onboardingCompleted: false,
  //     offerLetterLink: "",
  //     offerLetterStatus: "pending",
  //     offerLetterRemarks: "",
  //     salaryDetails: {
  //       offeredCTC: 0,
  //       monthlySalary: 0,
  //       currency: "INR",
  //       salaryMode: "monthly",
  //       components: {
  //         basic: 0,
  //         hra: 0,
  //         special: 0,
  //         bonus: 0,
  //         other: 0,
  //       },
  //       remarks: "",
  //     },
  //   },
  // });
  const [formData, setFormData] = useState({
    personalDetails: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      maritalStatus: "",
      gender: "",
    },
    reportingManagerName: "",
    reportingManagerEmployeeCode: "",
    reportingManagerId: "",
    reportingManagerObjId: "",
    designation: "",
    department: "",
    employeeId: "",
    joiningDate: "",
    offerDetails: {
      workSchedule: "",
      offerLetterDate: "",
      offerAcceptedDate: "",
      joiningDate: "",
      onboardingCompleted: false,
      offerLetterLink: "",
      offerLetterStatus: "pending",
      offerLetterRemarks: "",
      salaryDetails: {
        offeredCTC: 0,
        monthlySalary: 0,
        currency: "INR",
        salaryMode: "monthly",
        components: {
          basic: 0,
          hra: 0,
          special: 0,
          bonus: 0,
          other: 0,
        },
        remarks: "",
      },
    },
  });
  const [managerSearch, setManagerSearch] = useState("");
  const [managerOptions, setManagerOptions] = useState([]);
  const [managerSelected, setManagerSelected] = useState(false);
    const [loading, setLoading] = useState(false);

  console.log("formData", formData);

  let swtoken = getCookie("swtoken");

  const handleChange = (e, path) => {
    const keys = path.split(".");
    const newFormData = { ...formData };
    let obj = newFormData;
    while (keys.length > 1) {
      const key = keys.shift();
      obj[key] = { ...obj[key] };
      obj = obj[key];
    }
    obj[keys[0]] = e.target.value;
    setFormData(newFormData);
  };

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     if (managerSearch.length > 2) {
  //       searchManagers(managerSearch);
  //     } else {
  //       setManagerOptions([]);
  //     }
  //   }, 500);

  //   return () => clearTimeout(delayDebounce);
  // }, [managerSearch]);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (managerSearch.trim().length > 2 && !managerSelected) {
        searchManagers(managerSearch.trim());
      } else {
        setManagerOptions([]);
      }
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [managerSearch, managerSelected]);

  // const searchManagers = async (query) => {
  //   try {
  //     const res = await axios.post(`${apiurl}/api/employee/search`, {
  //       search: query,
  //       designation: ["assistant-manager", "team-leader"], // passed in body
  //       page: 1,
  //       limit: 10,
  //     });
  //     setManagerOptions(res.data.users || []);
  //   } catch (err) {
  //     console.error("Error fetching managers:", err);
  //   }
  // };
  const searchManagers = async (query) => {
    try {
      const res = await axios.post(
        `${apiurl}/api/employee/search`,
        {},
        {
          params: {
            search: query,
            page: 1,
            limit: 10,
            designation: "assistant-manager,team-leader", // optional filter
          },
        }
      );
      setManagerOptions(res.data.users || []);
    } catch (err) {
      console.error("Error fetching managers:", err);
      setManagerOptions([]);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Flatten all values for validation
  //   const {
  //     personalDetails: {
  //       firstName,
  //       lastName,
  //       email,
  //       phone,
  //       maritalStatus,
  //       gender,
  //     },
  //     reportingManagerName,
  //     designation,
  //     department,
  //     employeeId,
  //     joiningDate,
  //   } = formData;

  //   // Check for empty fields
  //   if (
  //     !firstName ||
  //     !lastName ||
  //     !email ||
  //     !phone ||
  //     !maritalStatus ||
  //     !gender ||
  //     !reportingManagerName ||
  //     !designation ||
  //     !department ||
  //     !employeeId ||
  //     !joiningDate
  //   ) {
  //     toast.error("❌ Please fill in all the fields before submitting.");
  //     return;
  //   }

  //   try {
  //     const res = await axios.post(`${apiurl}/api/employee/create`, formData, {
  //       headers: {
  //         Authorization: swtoken, // Make sure `swtoken` contains the token string like 'Bearer <token>'
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     toast.success("🎉 Employee created successfully!");
  //     window.location.reload();
  //   } catch (error) {
  //     console.error("Error creating employee:", error);
  //     toast.error("❌ Failed to create employee. Please try again.");
  //   }
  // };

  // Define options
  
  
   const handleSubmit = async (e) => {
    e.preventDefault();

    // Required fields
    const {
      personalDetails: { firstName, lastName, email, phone, maritalStatus, gender },
      reportingManagerName,
      designation,
      department,
      employeeId,
      joiningDate,
      offerDetails: {
        workSchedule,
        salaryDetails: { monthlySalary },
      },
    } = formData;

    if (
      !firstName ||
      !lastName ||
      !email ||
      !phone ||
      !maritalStatus ||
      !gender ||
      !reportingManagerName ||
      !designation ||
      !department ||
      !employeeId ||
      !joiningDate ||
      !workSchedule ||
      !monthlySalary
    ) {
      toast.error("❌ Please fill in all the required fields before submitting.");
      return;
    }

    try {
      setLoading(true); // disable button + show loading
      const res = await axios.post(`${apiurl}/api/employee/create`, formData, {
        headers: {
          Authorization: swtoken,
          "Content-Type": "application/json",
        },
      });
      toast.success("🎉 Employee created successfully!");
      navigation("/employees");
      // ✅ stay on same page without reload
      // If you want to clear form after creation:
      // setFormData(initialFormData)
    } catch (error) {
      console.error("Error creating employee:", error);
      toast.error("❌ Failed to create employee. Please try again.");
    } finally {
      setLoading(false); // re-enable button
    }
  };

  const departmentOptions = [
    "sales",
    "hr",
    "confirmation",
    "payroll",
    "mis",
    "marketing",
    "finance",
    "it-support",
    "operations",
    "customer-service",
    "training-and-development",
    "research-and-development",
    "legal",
    "administration",
    "quality-assurance",
    "logistics",
  ];

  const designationOptions = [
    "executive",
    "senior-executive",
    "team-lead",
    "senior-team-lead",
    "manager",
    "assistant-manager",
    "senior-manager",
    "payroll-specialist",
  ];

  const calculateSalaryComponents = (monthlySalary) => {
    const salary = parseFloat(monthlySalary);
    if (isNaN(salary) || salary <= 0) {
      return {
        offeredCTC: 0,
        basic: 0,
        hra: 0,
        other: 0,
      };
    }

    const offeredCTC = Math.round(salary * 12);
    const basic = Math.round(salary * 0.2);
    const hra = Math.round(basic * 0.5);
    const other = Math.round(salary - basic - hra);

    return {
      offeredCTC,
      basic,
      hra,
      other,
    };
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="flex flex-col items-center p-6 bg-gray-100  w-full">
          <h2 className="text-2xl font-bold mb-4">Create New Employee</h2>
          <form
            onSubmit={handleSubmit}
            className="space-y-6 bg-white p-6 rounded-xl shadow w-full"
          >
            <h3 className="text-xl font-semibold">Personal Details</h3>
            <div className="grid grid-cols-2 gap-4">
              <InputField
                label="First Name"
                name="firstName"
                value={formData.personalDetails.firstName}
                onChange={(e) => handleChange(e, "personalDetails.firstName")}
                placeholder="Enter First Name"
              />
              <InputField
                label="Last Name"
                name="lastName"
                value={formData.personalDetails.lastName}
                onChange={(e) => handleChange(e, "personalDetails.lastName")}
                placeholder="Enter Last Name"
              />
              <InputField
                label="Email"
                name="email"
                value={formData.personalDetails.email}
                onChange={(e) => handleChange(e, "personalDetails.email")}
                placeholder="Enter Email"
                type="email"
              />
              <InputField
                label="Phone"
                name="phone"
                value={formData.personalDetails.phone}
                onChange={(e) => handleChange(e, "personalDetails.phone")}
                placeholder="Enter Phone Number"
              />
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Gender
                </label>
                <select
                  name="gender"
                  value={formData.personalDetails.gender}
                  onChange={(e) => handleChange(e, "personalDetails.gender")}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Status</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">other</option>
                </select>
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Marital Status
                </label>
                <select
                  name="maritalStatus"
                  value={formData.personalDetails.maritalStatus}
                  onChange={(e) =>
                    handleChange(e, "personalDetails.maritalStatus")
                  }
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Status</option>
                  <option value="unmarried">Unmarried</option>
                  <option value="married">Married</option>
                  <option value="widowed">Widowed</option>
                  <option value="divorced">Divorced</option>
                </select>
              </div>
            </div>

            <h3 className="text-xl font-semibold mt-6">Job Information</h3>
            <div className="grid grid-cols-2 gap-4">
              <InputField
                label="Reporting Manager"
                name="reportingManagerName"
                value={managerSearch}
                onChange={(e) => {
                  setManagerSearch(e.target.value);
                  setManagerSelected(false); // reset selection on typing
                }}
                placeholder="Search and Select Manager"
              />
              {managerOptions.length > 0 && !managerSelected && (
                <ul className="absolute z-10 w-full bg-white border mt-1 max-h-40 overflow-y-auto rounded-lg shadow">
                  {managerOptions.map((manager) => (
                    <li
                      key={manager._id}
                      onClick={() => {
                        const fullName =
                          manager.personalDetails.firstName +
                          " " +
                          manager.personalDetails.lastName;

                        setFormData((prev) => ({
                          ...prev,
                          reportingManagerName: fullName,
                          reportingManagerEmployeeCode: manager.employeeId,
                          reportingManagerId: manager.employeeId,
                          reportingManagerObjId: manager._id,
                        }));
                        setManagerSearch(fullName);
                        setManagerOptions([]);
                        setManagerSelected(true);
                      }}
                      className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                    >
                      {manager.personalDetails.firstName}{" "}
                      {manager.personalDetails.lastName} - {manager.employeeId}
                    </li>
                  ))}
                </ul>
              )}

              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Designation
                </label>
                <select
                  name="designation"
                  value={formData.designation}
                  onChange={(e) => handleChange(e, "designation")}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Designation</option>
                  {designationOptions.map((role) => (
                    <option key={role} value={role}>
                      {role
                        .replace(/-/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase())}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Department
                </label>
                <select
                  name="department"
                  value={formData.department}
                  onChange={(e) => handleChange(e, "department")}
                  className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Department</option>
                  {departmentOptions.map((dept) => (
                    <option key={dept} value={dept}>
                      {dept
                        .replace(/-/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase())}
                    </option>
                  ))}
                </select>
              </div>

              <InputField
                label="Employee ID (Please Enter Only Number)"
                name="employeeId"
                value={formData.employeeId}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleChange(e, "employeeId");
                  }
                }}
                placeholder="Enter Employee ID"
                type="text"
              />
              <InputField
                label="Joining Date"
                name="joiningDate"
                value={formData.joiningDate}
                onChange={(e) => handleChange(e, "joiningDate")}
                type="date"
              />
            </div>
            <div className="">
              <h2 className="text-lg font-semibold mb-4">
                Offer & Salary Details
              </h2>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    Work Schedule
                  </label>
                  <select
                    value={formData.offerDetails.workSchedule}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        offerDetails: {
                          ...prev.offerDetails,
                          workSchedule: e.target.value,
                        },
                      }))
                    }
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select </option>
                    <option value="rotational">Rotational</option>
                    <option value="5-day">5-day</option>
                    <option value="6-day">6-day</option>
                  </select>
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    Monthly Salary
                  </label>
                  <input
                    type="number"
                    value={
                      formData.offerDetails.salaryDetails?.monthlySalary || 0
                    }
                    // onChange={(e) =>
                    //   setFormData((prev) => ({
                    //     ...prev,
                    //     offerDetails: {
                    //       ...prev.offerDetails,
                    //       salaryDetails: {
                    //         ...prev.offerDetails.salaryDetails,
                    //         monthlySalary: Number(e.target.value),
                    //       },
                    //     },
                    //   }))
                    // }
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      const calculated = calculateSalaryComponents(value);

                      setFormData((prev) => ({
                        ...prev,
                        offerDetails: {
                          ...prev.offerDetails,
                          salaryDetails: {
                            ...prev.offerDetails.salaryDetails,
                            monthlySalary: value,
                            offeredCTC: calculated.offeredCTC,
                            components: {
                              ...prev.offerDetails.salaryDetails.components,
                              basic: calculated.basic,
                              hra: calculated.hra,
                              other: calculated.other,
                            },
                          },
                        },
                      }));
                    }}
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Offered CTC (Yearly)
                  </label>
                  <input
                    type="number"
                    value={formData.offerDetails.salaryDetails?.offeredCTC || 0}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        offerDetails: {
                          ...prev.offerDetails,
                          salaryDetails: {
                            ...prev.offerDetails.salaryDetails,
                            offeredCTC: Number(e.target.value),
                          },
                        },
                      }))
                    }
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Currency
                  </label>
                  <input
                    type="text"
                    readOnly
                    value={formData.offerDetails.salaryDetails?.currency || ""}
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Salary Mode
                  </label>
                  <input
                    type="text"
                    readOnly
                    value={
                      formData.offerDetails.salaryDetails?.salaryMode || ""
                    }
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Basic
                  </label>
                  <input
                    type="number"
                    // value={calculateSalaryComponents(
                    //   formData.offerDetails.salaryDetails?.monthlySalary
                    // ).basic.toFixed(2)}
                    value={formData.offerDetails.salaryDetails.components.basic}
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    HRA
                  </label>
                  <input
                    type="number"
                    // value={calculateSalaryComponents(
                    //   formData.offerDetails.salaryDetails?.monthlySalary
                    // ).hra.toFixed(2)}
                    value={formData.offerDetails.salaryDetails.components.hra}
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Special
                  </label>
                  <input
                    type="number"
                    value={
                      formData.offerDetails.salaryDetails?.components
                        ?.special || 0
                    }
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        offerDetails: {
                          ...prev.offerDetails,
                          salaryDetails: {
                            ...prev.offerDetails.salaryDetails,
                            components: {
                              ...prev.offerDetails.salaryDetails?.components,
                              special: Number(e.target.value),
                            },
                          },
                        },
                      }))
                    }
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Bonus
                  </label>
                  <input
                    type="number"
                    value={
                      formData.offerDetails.salaryDetails?.components?.bonus ||
                      0
                    }
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        offerDetails: {
                          ...prev.offerDetails,
                          salaryDetails: {
                            ...prev.offerDetails.salaryDetails,
                            components: {
                              ...prev.offerDetails.salaryDetails?.components,
                              bonus: Number(e.target.value),
                            },
                          },
                        },
                      }))
                    }
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Other
                  </label>
                  <input
                    type="number"
                    // value={calculateSalaryComponents(
                    //   formData.offerDetails.salaryDetails?.monthlySalary
                    // ).other.toFixed(2)}
                    value={formData.offerDetails.salaryDetails.components.other}
                    readOnly
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="col-span-2">
                  <label className="text-sm font-medium text-gray-700">
                    Salary Remarks
                  </label>
                  <textarea
                    placeholder="Salary Remarks"
                    className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.offerDetails.salaryDetails?.remarks || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        offerDetails: {
                          ...prev.offerDetails,
                          salaryDetails: {
                            ...prev.offerDetails.salaryDetails,
                            remarks: e.target.value,
                          },
                        },
                      }))
                    }
                  />
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-2 rounded-lg shadow text-white ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {loading ? "Creating..." : "Create Employee"}
            </button>
          </form>
        </div>
      </Container>
    </Layout>
  );
};

export default CreateEmployee;
